import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

export const addToCartApi = async (data) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(
      `${baseUrl}admin/addToCart/api/v1/create-cart`,
      data,
      {
        headers: {
          "auth-token": token,
          "Content-Type": "application/json",
        },
      },
    );
    console.log("add to cart response ", response);
    return response;
  } catch (error) {
    console.error("Error fetching products:", error);

    throw error;
  }
};

export const updateCartApi = async (cartId, data) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.put(
      `${baseUrl}admin/addToCart/api/v1/update-cart/${cartId}`,
      data,
      {
        headers: {
          // "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );
    return response;
  } catch (error) {
    console.error("Error updating cart:", error);
    throw error;
  }
};
export const deleteCartItem = async (ROWID) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.delete(
      `${baseUrl}admin/addToCart/api/v1/delete-cart/${ROWID}`,
      {
        headers: {
          "Content-Type": "application/json",
          "auth-token": token,
        },
      },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteCartItemThunk = createAsyncThunk(
  "client/delete-from-cart",
  async (ROWID, { rejectWithValue }) => {
    const token = localStorage.getItem("authToken");
    try {
      const response = await axios.delete(
        `${baseUrl}admin/addToCart/api/v1/delete-cart/${ROWID}`,
        {
          headers: {
            // "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      // Simplify payload for the frontend
      const deletedRows =
        response?.data?.cart?.[0]?.carts?.DELETED_ROWS_COUNT || 0;
      const success = response?.data?.success || false;
      const message = response?.data?.message || "Failed to delete cart item";

      return { success, deletedRows, message };
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error deleting cart item",
      );
    }
  },
);

export const deleteFromCartApi = createAsyncThunk(
  "client/delete-from-cart",
  async (data, { rejectWithValue }) => {
    const token = localStorage.getItem("authToken");

    try {
      const response = await axios.post(
        `${baseUrl}admin/addToCart/api/v1/delete-cart`,
        data,
        {
          headers: {
            // "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );
      return response; // ✅ Return only the data
    } catch (error) {
      console.error("Error fetching products:", error);

      // ✅ Handle errors properly
      return rejectWithValue(
        error.response?.data?.message || "error in delete from cart product",
      );
    }
  },
);

export const clearCartApi = createAsyncThunk(
  "client/clear-multiple-cart",
  async (rowIds, { rejectWithValue }) => {
    const token = localStorage.getItem("authToken");

    try {
      const response = await axios.delete(
        `${baseUrl}admin/addToCart/api/v1/delete-multiple-carts`,
        {
          data: rowIds, // 👈 BODY goes here for axios.delete
          headers: {
            // "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error("Error clearing cart:", error);
      return rejectWithValue(
        error.response?.data?.message || "error in clear cart",
      );
    }
  },
);

// update cart product details
export const updateCartProductApi = createAsyncThunk(
  "client/cart-update",
  async (data, { rejectWithValue }) => {
    const token = localStorage.getItem("authToken");
    try {
      const response = await axios.put(
        `${baseUrl}webapp/cart/api/v1/cart-update`,
        data,
        {
          headers: {
            // "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );
      return response; // ✅ Return only the data
    } catch (error) {
      console.error("Error fetching products:", error);
      // ✅ Handle errors properly
      return rejectWithValue(
        error.response?.data?.message || "error in update cart product",
      );
    }
  },
);

export const getCartByWebUserId = async () => {
  const userId = localStorage.getItem("UserRowId");
  const token = localStorage.getItem("authToken");

  if (!userId) {
    throw new Error("User ID not found");
  }

  try {
    const response = await axios.post(
      `${baseUrl}admin/addToCart/api/v1/cart-details-by-webuserId/${userId}`, // ✅ FIX HERE
      {},
      {
        // empty body
        headers: {
          // "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching cart:", error);
    throw error;
  }
};
